import { BrowserRouter, useRoutes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GlobalProvider } from 'standard';
import ThemeProvider from './theme';
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { routesConfig } from './config';


function Router() {
  const routes = useRoutes(routesConfig);
  return routes;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ThemeProvider>
          <ScrollToTop />
          <StyledChart />
          <GlobalProvider>
            <Router />
          </GlobalProvider>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
